import React from "react";
import { Navigate } from "react-router-dom";

export default function JobApply() {
  return <Navigate to="/career" replace />;
}